import { jsxs as o, jsx as l } from "react/jsx-runtime";
const a = (r) => /* @__PURE__ */ o(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...r,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M37.346 32.844c0-.931-.238-1.806-.657-2.568l10.03-10.03-2.122-2.12-10.03 10.028a5.346 5.346 0 1 0 2.778 4.69ZM32 35.19a2.348 2.348 0 0 1-2.346-2.346A2.349 2.349 0 0 1 32 30.498a2.349 2.349 0 0 1 2.346 2.346A2.348 2.348 0 0 1 32 35.19Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M32 11.197a21.703 21.703 0 0 1 15.448 6.399 21.704 21.704 0 0 1 6.399 15.448c0 .895-.055 1.781-.16 2.656 1.35.832 2.539 1.9 3.508 3.15.43-1.883.652-3.828.652-5.806 0-6.904-2.689-13.395-7.57-18.276C45.394 9.885 38.903 7.197 32 7.197c-6.904 0-13.395 2.688-18.276 7.57-4.882 4.881-7.57 11.372-7.57 18.276 0 4.156.975 8.163 2.817 11.759h4.61a21.698 21.698 0 0 1-3.428-11.76 21.704 21.704 0 0 1 6.4-15.447A21.703 21.703 0 0 1 32 11.197ZM51.823 41.996 45.94 47.88l-3.032-3.032-2.122 2.122 5.154 5.153 6.78-6.781-.896-3.346Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M46.874 35.748c-6.145 0-11.126 4.981-11.126 11.126S40.729 58 46.874 58 58 53.02 58 46.874 53.02 35.748 46.874 35.748Zm0 19.252c-4.48 0-8.126-3.645-8.126-8.126 0-4.48 3.645-8.126 8.126-8.126 4.48 0 8.126 3.645 8.126 8.126C55 51.354 51.355 55 46.874 55Z"
        }
      )
    ]
  }
);
export {
  a as RealCharge
};
